import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import { router } from './_helpers';
import store from './_store';
import { createPinia } from 'pinia'
import './geo';
import { components } from "./components"
import { directives } from "./directives";
// import { BrowserTracing } from "@sentry/tracing";
import object from "./_helpers/object";
// https://www.npmjs.com/package/maska
import { vMaska } from "maska/vue"

import { createYmaps } from 'vue-yandex-maps';
import VCalendar from 'v-calendar';
import { initSentry } from "./initSentry"
import 'v-calendar/style.css';
import 'vue-draggable-resizable/style.css';
import moment from 'moment';
import 'moment/locale/ru';

configureCompat({
  COMPONENT_V_MODEL: false,
  // INSTANCE_SET: false,
})
const pinia = createPinia()
const app = createApp(App);

app.use(createYmaps({
  apikey: `${process.env.VUE_APP_YANDEX_KEY_V3}`,
  importModules: ['@yandex/ymaps3-layers-extra'],
}));

app.use(VCalendar);

moment.locale('ru');
app.use(require('vue-moment'));

window.object = new object();

app.directive('maska', vMaska);

directives.forEach(element => {
  app.directive(element.name, element.directive);
});

components.forEach(element => {
  app.component(element.name, element);
});

initSentry()

app.use(store)
app.use(pinia)
app.use(router)
app.mount('#app')